export default __webpack_public_path__ + "static/media/highlights_2880.0462f7c4.webp";